import "hammerjs";
import * as React from "react";
import { Link } from "react-router-dom";
import Spinner from "../../core/Spinner/Spinner";
import { ITranslationProps, translateComponent } from "../../helpers/translation";
import IMessageTotalsByMonthResponse from "../../types/IMessageTotalsByMonthResponse";
import IUserSession from "../../types/IUserSession";
import MessageTotalsByMonthChart from "./MessageTotalsByMonthChart";
import MessageTotalsByMonthTable from "./MessageTotalsByMonthTable";

interface IDashboardProps extends ITranslationProps {
    messageTotalsByMonth: IMessageTotalsByMonthResponse[];
    userSession: IUserSession | null;
    loading: boolean;
}

class Dashboard extends React.Component<IDashboardProps> {

    constructor(props: IDashboardProps) {
        super(props);
    }

    public render() {

        const menuNodes: React.ReactNode[] = [];
        if (this.props.userSession) {
            this.props.userSession.menus.forEach((menu, menuIndex) => {
                const menuLinks: React.ReactNode[] = [];
                menu.menuItems.forEach((menuItem, menuItemIndex) => {
                    menuLinks.push(<div key={menuItemIndex}><Link to={menuItem.url}>{menuItem.name}</Link></div>);
                });

                menuNodes.push(<div className="col-md" key={menuIndex}>
                    <div><strong>{menu.name}</strong></div>
                    {menuLinks}
                </div>);

            });
        }


        return (

            <div className="pb-5">

                <h2>{this.props.t("Dashboard.Title")}</h2>
                <div className="row">

                    <div className="col-md-6">
                        <div className="card">
                            <div className="card-body">
                                <h5 className="card-title">{this.props.t("Dashboard.MessageTotalsByMonthLabel")}</h5>
                                {this.props.loading && <Spinner showCircleOnly={true} circleSize={20} />}
                                {this.props.messageTotalsByMonth !== null && this.props.messageTotalsByMonth.length > 0 &&
                                    <MessageTotalsByMonthTable messageTotals={this.props.messageTotalsByMonth} />
                                }
                            </div>
                        </div>

                        <div className="card mt-3">
                            <div className="card-body">
                                <h5 className="card-title">{this.props.t("Dashboard.QuickLinks")}</h5>
                                <div className="row">{menuNodes}</div>
                            </div>
                        </div>
                    </div>

                    <div className="col-md-6">
                        <div className="card">
                            <div className="card-body">
                                <h5 className="card-title">{this.props.t("Dashboard.MessageTotalsByMonthLabel")}</h5>
                                {this.props.loading && <Spinner showCircleOnly={true} circleSize={20} />}
                                {this.props.messageTotalsByMonth !== null && this.props.messageTotalsByMonth.length > 0 &&
                                    <MessageTotalsByMonthChart messageTotals={this.props.messageTotalsByMonth} />
                                }
                            </div>
                        </div>
                    </div>



                </div>
            </div>
        );
    }

}

export default translateComponent(Dashboard);



// WEBPACK FOOTER //
// ./src/components/Dashboard/Dashboard.tsx